module.exports = __webpack_public_path__ + "static/media/logo_pf.fa51a7b6.png";